import { noop } from 'lodash'
import { createContext, useContext, useMemo, useState } from 'react'
import { Outlet } from 'react-router-dom'

import { INoteFiltersForm } from '../modules/reporting/components/notes-filters'
import { RequireAuth } from './RequireAuth'

interface ContextType {
  filters: INoteFiltersForm
  setFilters: typeof noop
}

const DEFAULT_STATE = {
  filters: {},
  setFilters: noop
}
export const NotesFiltersContext = createContext<ContextType>(DEFAULT_STATE)
export const useNotesFiltersContext = () => useContext(NotesFiltersContext)

export const ReportingWrapper = () => {
  const [filters, setFilters] = useState({})
  const contextValue = useMemo(
    () => ({
      filters,
      setFilters
    }),
    [filters]
  )

  return (
    <RequireAuth permissionRequired="trade.view">
      <NotesFiltersContext.Provider value={contextValue}>
        <Outlet />
      </NotesFiltersContext.Provider>
    </RequireAuth>
  )
}
